import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { BluePrinter } from 'Images';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';

export const PrintForm = () => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.CompassRights)
    .compassRightsHeader.printForm;

  return (
    <Stack
      alignItems='center'
      width='max-content'
      sx={{ ':hover': { cursor: 'pointer', textDecoration: 'underline' } }}
      onClick={() => window.print()}
      onKeyDown={(event) => onEnterOrEscapeKeyDown(event)}
      tabIndex={0}
      aria-label={dictionary}
      role='button'
      flexDirection={'row'}
      gap={'4px'}
    >
      <Avatar
        src={BluePrinter}
        alt={''}
        sx={{ width: '24px', height: '24px' }}
      />
      <Typography variant={'body7'} color={'primary.main'}>
        {dictionary}
      </Typography>
    </Stack>
  );
};
